import { mmFetchWithResponse } from './mmFetchWithResponse';

/**
 * API client for the BAMS (Blue Apron / Marley Spoon) pack line shorts dashboard.
 * All endpoints are read-only and gated by the VIEW_BAMS_SHORTS auth role.
 */
const bamsShortsApi = {
    /**
     * Aggregate feed for a pack week (brand x facility x pack date).
     * Omit week/year to let the server default to the current ISO pack week.
     */
    getFeed: async (week, year) => {
        const params = new URLSearchParams();
        if (week) params.set('week', week);
        if (year) params.set('year', year);
        const qs = params.toString();
        const url = `api/operations/visibility/bams-shorts/v1/feed${qs ? `?${qs}` : ''}`;
        return mmFetchWithResponse(url);
    },
    /**
     * SKU-level detail for a pack week (brand x facility x SKU).
     */
    getSkuDetail: async (week, year) => {
        const params = new URLSearchParams();
        if (week) params.set('week', week);
        if (year) params.set('year', year);
        const qs = params.toString();
        const url = `api/operations/visibility/bams-shorts/v1/skuDetail${qs ? `?${qs}` : ''}`;
        return mmFetchWithResponse(url);
    },
    /**
     * Aggregate feed by local pack date and pack line (Day & line tab).
     */
    getDayLine: async (week, year) => {
        const params = new URLSearchParams();
        if (week) params.set('week', week);
        if (year) params.set('year', year);
        const qs = params.toString();
        const url = `api/operations/visibility/bams-shorts/v1/dayLine${qs ? `?${qs}` : ''}`;
        return mmFetchWithResponse(url);
    },
    /**
     * SKU detail by local pack date (Day & line tab, top-items grid).
     */
    getDayLineSku: async (week, year) => {
        const params = new URLSearchParams();
        if (week) params.set('week', week);
        if (year) params.set('year', year);
        const qs = params.toString();
        const url = `api/operations/visibility/bams-shorts/v1/dayLineSku${qs ? `?${qs}` : ''}`;
        return mmFetchWithResponse(url);
    },
    /**
     * Live view of out-of-stock scans in the last 24 hours (Live tab).
     */
    getLive: async () => {
        const url = `api/operations/visibility/bams-shorts/v1/live`;
        return mmFetchWithResponse(url);
    },
    /**
     * Live inventory state for a set of shorted SKUs.
     * @param {Array<number|string>} skus external SKU numbers
     */
    getInventory: async (skus) => {
        const list = (skus || []).join(',');
        const url = `api/operations/visibility/bams-shorts/v1/inventory?skus=${encodeURIComponent(list)}`;
        return mmFetchWithResponse(url);
    },
    /**
     * On-demand location drill-down for a single shorted SKU at a facility, scoped to
     * the shorting brand's company source (blue_apron | marley_spoon).
     */
    getLocations: async (facilityId, externalSku, companySource) => {
        const url = `api/operations/visibility/bams-shorts/v1/locations?facilityId=${facilityId}&externalSku=${encodeURIComponent(
            externalSku,
        )}&companySource=${encodeURIComponent(companySource)}`;
        return mmFetchWithResponse(url);
    },
};

export { bamsShortsApi };
